import React from 'react';
import classNames from 'classnames';

import IconSearch16 from './IconSearch16';
import IconSearch24 from './IconSearch24';

import styles from './SearchPrimary.module.scss';

export interface SearchPrimaryProps {
  inputRef?: React.LegacyRef<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  size?: 'small' | 'med' | 'large';
  value?: string;
}

const iconLookup = {
  small: IconSearch16,
  med: IconSearch16,
  large: IconSearch24,
};

function SearchPrimary({
  inputRef = React.createRef(),
  onChange,
  placeholder = 'Search',
  size = 'small',
  value,
}: SearchPrimaryProps) {
  const Icon = iconLookup[size];

  return (
    <div className={classNames(styles.searchprimary, styles[size])}>
      <input
        type="search"
        name="search"
        autoComplete="off"
        ref={inputRef}
        onChange={onChange}
        className={classNames(styles.searchInput)}
        value={value}
        placeholder={placeholder}
      />
      <Icon className={styles.leadingIcon} />
    </div>
  );
}

export default SearchPrimary;
